import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-2" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["textContent"]

import { ref } from 'vue';
import Menu from 'primevue/menu';
import Dialog from 'primevue/dialog';
import { EMIT, PERMISSIONS } from '@/enum';
import { can } from '@/composables';


export default /*@__PURE__*/_defineComponent({
  __name: 'BuildingsListActions',
  emits: [EMIT.CANCEL, EMIT.SAVE, EMIT.CLOSE, EMIT.EDIT],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const menu = ref();

const toggle = (event: Event): void => menu.value.toggle(event);

const visible = ref(false);

const openDeleteBuildingModal = () => {
  visible.value = true;
  menu.value.hide();
};

const openEditBuildingModal = () => {
  emit(EMIT.EDIT);
  menu.value.hide();
  visible.value = false;
};

const menuItems = (() => {
  return [
    {
      label: 'Edit Building',
      icon: {
        name: 'edit',
        styles: 'inline-block text-lg text-orange-500',
      },
      command: openEditBuildingModal,
      visible: can([PERMISSIONS.BUILDING_MANAGE]),
    },
    {
      label: 'Delete Building',
      icon: {
        name: 'delete',
        styles: 'inline-block text-lg text-red-500',
      },
      command: openDeleteBuildingModal,
      visible: can([PERMISSIONS.BUILDING_ASSIGN]),
    },
  ];
})();

function submit() {
  emit(EMIT.SAVE);
  visible.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "ml-3 cursor-pointer",
      onClick: toggle
    }, [
      _createVNode(_component_Icon, {
        name: "more_horiz",
        class: "text-lg p-1"
      }),
      _createVNode(_unref(Menu), {
        id: "overlay_menu",
        ref_key: "menu",
        ref: menu,
        class: "mt-2 ml-2 p-2",
        model: _unref(menuItems),
        popup: true
      }, {
        item: _withCtx(({ item }: { item: any }) => [
          _createElementVNode("div", _hoisted_1, [
            (item.command)
              ? (_openBlock(), _createElementBlock("a", _hoisted_2, [
                  _createVNode(_component_Icon, {
                    name: item.icon?.name,
                    class: _normalizeClass(item.icon?.styles)
                  }, null, 8, ["name", "class"]),
                  _createElementVNode("span", {
                    class: "relative inline-block ml-2 text-sm text-800",
                    textContent: _toDisplayString(item.label)
                  }, null, 8, _hoisted_3)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createVNode(_unref(Dialog), {
      visible: visible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
      modal: "",
      header: "Delete Building",
      closable: true,
      style: {"width":"500px"}
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_AppButton, {
          text: "Cancel",
          type: "secondary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = false))
        }),
        _createVNode(_component_AppButton, {
          text: "Save",
          type: "primary",
          onClick: submit
        })
      ]),
      default: _withCtx(() => [
        _cache[2] || (_cache[2] = _createElementVNode("p", null, "Are you sure you want to delete this building?", -1))
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})